var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"dyt-protocol"},[_c('div',{staticClass:"iframe-wrap"},[_c('iframe',{attrs:{"src":_vm.src}})]),_c('div',{staticClass:"dyt-btn-group"},[_c('div',{staticClass:"btn commit",on:{"click":_vm.goBack}},[_vm._v("关闭")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }